import { Component, OnInit, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';

import { languages } from '../../helpers';
import { AuthService } from '../../../auth';
import { LanguageService } from '../../services';

@Component({
  selector: 'app-language-select',
  templateUrl: './language-select.component.html',
  styleUrl: './language-select.component.scss',
  imports: [FormsModule, AsyncPipe],
})
export class LanguageSelectComponent implements OnInit {
  protected readonly languageService = inject(LanguageService);
  private readonly authService = inject(AuthService);

  readonly languages = languages;

  protected isAuthenticated: Observable<boolean>;

  ngOnInit(): void {
    this.isAuthenticated = this.authService.isAuthenticated();
  }

  setLanguage(event: any) {
    this.languageService.setLanguage(event.target.value).subscribe();
  }
}
